<template>
  <div class="intro-y col-span-12 overflow-auto lg:overflow-visible">
    <div
      class="
        intro-y
        col-span-12
        flex flex-wrap
        items-center
        mt-2
      "
    >
      <div class="my-5">
        <button class="button shadow-md m-3.5" @click="filterAll()">
          <strong v-if="showStudentData">Show Project Data</strong
          ><strong v-else>Show Student Data</strong>
        </button>
      </div>

      <div class="w-full sm:w-auto mt-3 sm:mt-0 sm:ml-auto md:ml-0">
        <div class="w-56 relative text-gray-700 dark:text-gray-300">
          <input
            @input="search"
            type="text"
            v-model="searchData"
            class="input w-56 box pr-10 placeholder-theme-13"
            placeholder="Search by student name"
          />
          <SearchIcon class="w-4 h-4 absolute my-auto inset-y-0 mr-3 right-0" />
        </div>
      </div>
      <div
        class="
        intro-y
        col-span-12
        flex flex-wrap
        sm:flex-no-wrap
        items-center
        mt-2
      "
      >
        <button
          class="button bg-blue-800 text-white mt-2 shadow-md mr-2"
          @click="sortByLikeCount()"
        >
          Sort By Likes
        </button>
        <button
          class="button bg-blue-800 text-white mt-2 shadow-md mr-2"
          @click="sortByViewCount()"
        >
          Sort By Views
        </button>
        <button
          class="button bg-blue-800 text-white mt-2 shadow-md mr-2"
          @click="sortByProjectCount()"
        >
          Sort By Project Count
        </button>
      </div>
      <div style="padding-top: 20px">
        <input
          type="text"
          v-model="from"
          class="input w-56 box pr-10 placeholder-theme-13"
          placeholder="From"
        />
        <input
          type="text"
          v-model="to"
          class="input w-56 box pr-10 placeholder-theme-13"
          placeholder="To"
        />
        <button class="button shadow-md mr-2" @click="getAnalyticsByInterval()">
          Filter by interval
        </button>
      </div>

      <!-- new code -->
      <vue-json-to-csv
        :json-data="analytics"
        :labels="{
          user_id: { title: 'user_id' },
          student_id: { title: 'Student Name' },
          project_name: { title: 'Project Name' },
          like_count: { title: 'Number of Likes' },
          view_count: { title: 'Number of Views' },
          project_count: { title: 'Total number of Projects' },
        }"
        csv-title="data"
      >
        <button class="button bg-blue-800 text-white mt-2 shadow-md mr-2">
          <b>Download project data</b>
        </button>
      </vue-json-to-csv>
      <!-- new code -->
       <div v-if="showStudentData" class="w-2/4">
            <div class="col-span-12 grid grid-cols-6 gap-4 mt-8" >
          <div
            class="col-span-12 sm:col-span-6 xxl:col-span-3 intro-y"
            v-for="(q, i) in studentData"
            :key="i"
          >
            <div class="box p-5 zoom-in">
              <div class="flex items-center">
                <div class="w-2/4 flex-none">
                  <div class="text-lg font-medium truncate">
                    {{ q.student_id }}
                  </div>
                  <div class="text-huge mt-1 font-medium">
                    {{ q.like_count }} Likes
                  </div>
                  <div class="text-huge mt-1 font-medium">
                    {{ q.view_count }} Views
                  </div>
                  <div class="text-huge mt-1 font-medium">
                    {{ q.project_count }} Projects
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
       </div>
      <div class="col-span-12 grid grid-cols-12 gap-6 mt-8" v-else>
        <div
          class="col-span-12 sm:col-span-6 xxl:col-span-3 intro-y"
          v-for="(q, i) in analytics"
          :key="i"
        >
          <div class="box p-5 zoom-in">
            <div class="flex items-center">
              <div class="w-2/4 flex-none">
                <div class="text-huge mt-1 font-medium">{{ i + 1 }}</div>
                <div class="text-lg font-medium truncate">
                  {{ q.project_name }}
                </div>
                <div class="text-huge mt-1 font-medium">{{ q.student_id }}</div>
                <div class="text-huge mt-1 font-medium">
                  {{ q.like_count }} Likes
                </div>
                <div class="text-huge mt-1 font-medium">
                  {{ q.view_count }} Views
                </div>
                <div class="text-huge mt-1 font-medium">
                  {{ q.project_count }} Projects
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueJsonToCsv from "vue-json-to-csv";
export default {
  name: "UTableVue",
  components: {
    // Button
    // Uploader
    VueJsonToCsv,
  },
  data() {
    return {
      analytics: {},
      domains: [],
      subjects: [],
      absoluteData: [],
      studentData: {},
      showStudentData: false,
      searchData: "",
      from: "",
      to: "",
    };
  },
  created() {
    this.getAnalytics();
  },
  methods: {
    sortByLikeCount() {
      this.analytics.sort((a, b) => b.like_count - a.like_count);
    },

    sortByViewCount() {
      this.analytics.sort((a, b) => b.view_count - a.view_count);
    },
    sortByProjectCount() {
      this.analytics.sort((a, b) => b.project_count - a.project_count);
    },
    search() {
      if (this.searchData.length > 1) {
        this.analytics = this.absoluteData.filter((o) =>
          o.student_id.toLowerCase().includes(this.searchData.toLowerCase())
        );
      } else {
        this.analytics = [...this.absoluteData];
      }
    },
    filterAll() {
      this.showStudentData = !this.showStudentData;
    },
    getAnalytics() {
      this.$upskill.projectAnalytics().then((res) => {
        this.absoluteData = res.data.data;
        this.analytics = res.data.data;
        this.analytics.forEach((element) => {
          if (this.studentData[element.user_id]) {
            this.studentData[element.user_id].like_count += element.like_count;
            this.studentData[element.user_id].view_count += element.view_count;
          } else {
            this.studentData[element.user_id] = {
              student_id: element.student_id,
              like_count: element.like_count,
              view_count: element.view_count,
              project_count: element.project_count,
            };
          }
        });
      });
    },
    getAnalyticsByInterval() {
      this.$upskill
        .projectAnalyticsByInterval(this.from, this.to)
        .then((res) => {
          this.absoluteData = res.data.data;
          this.analytics = res.data.data;
          this.analytics.forEach((element) => {
            if (this.studentData[element.user_id]) {
              this.studentData[element.user_id].like_count +=
                element.like_count;
              this.studentData[element.user_id].view_count +=
                element.view_count;
            } else {
              this.studentData[element.user_id] = {
                student_id: element.student_id,
                like_count: element.like_count,
                view_count: element.view_count,
                project_count: element.project_count,
              };
            }
          });
        });
    },
  },
};
</script>

<style scoped></style>
